import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';

import { ClarityModule } from '@clr/angular';
import { VcaCommonModule } from '../../../../../common';

import { DpsCommonModule } from '../../dataprotection-common/dataprotection-common.module';
import { DpsOpsCommonModule } from '../common-ops/common-ops.component';

import { DatacenterDetails } from '../manage/datacenter/datacenter-details-vc.component';
import { ResourcePoolDetails } from '../manage/resource-pool/resource-pool-details-vc.component';
import { VirtualMachineDetails } from '../manage/virtual-machine/virtual-machine-details-vc.component';
import { DefaultPageDetails } from '../manage/default-page/default-page-details-vc.component';

import { ApplyPolicy } from '../apply-policy/apply-policy.component';
import { DeletePolicy } from '../delete-policy/delete-policy.component';
import { AdhocBackup } from '../adhoc-backup/adhoc-backup.component';
import { ConfigureEmail } from '../configure-email/configure-email.component';

@NgModule({
    declarations: [
        DefaultPageDetails,
        DatacenterDetails,
        ResourcePoolDetails,
        VirtualMachineDetails,
        ApplyPolicy,
        DeletePolicy,
        AdhocBackup,
        ConfigureEmail
    ],
    imports: [
        BrowserModule,
        CommonModule,
        FormsModule,
        VcaCommonModule,
        TranslateModule,
        ClarityModule.forRoot(),
        DpsCommonModule,
        DpsOpsCommonModule
    ],
    providers: [
    ],
    exports: [
        DefaultPageDetails,
        DatacenterDetails,
        ResourcePoolDetails,
        VirtualMachineDetails,
        ApplyPolicy,
        DeletePolicy,
        AdhocBackup,
        ConfigureEmail
    ]

})
export class DpsEntitiesModule {
    constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vc/manage/dps-entities.module.ts